<template>
    <div class="t-lk-success t-lk-modal__invite" :class="props.class">
        <h3 class="t-lk-modal__title t-lk-success__title">{{ $root.staticText.lk.inviteSuccess }}</h3>
        <div class="t-lk-success__text">
            {{ $root.staticText.lk.inviteSuccessText }}
            <a :href="'mailto:' + props.email" class="t-lk-modal__invite-link">{{ props.email }}</a>
            {{ $root.staticText.lk.inviteSuccessText2 }}
        </div>
        <div @click="modalClose" class="t-lk-success__btn t-btn _border-green _lk">
            {{ $root.staticText.lk.inviteSuccessBtn }}
        </div>
    </div>
</template>

<script>
    import {mapActions} from "vuex";

    export default {
        props: ['props'],
        methods: {
            ...mapActions('modal', ['modalClose']),
        }
    }
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/templates/components/base/modals/lk-success-invite.vue